import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetailPage, serviceDetailHead } from "@/components/site/ServiceDetailPage";
import { serviceDetails } from "@/lib/service-details";

const service = serviceDetails.find((s) => s.slug === "finance-process-outsourcing")!;

export const Route = createFileRoute("/services/finance-process-outsourcing")({
  head: () => serviceDetailHead(service),
  component: () => <ServiceDetailPage service={service} />,
});
